export const CANCEL_SEARCH = 'CANCEL_SEARCH';
export const CLOSE_PANEL = 'CLOSE_PANEL';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const FIND_IN_DOCUMENT = 'FIND_IN_DOCUMENT';
export const FIT_TO_WIDTH_OFF = 'FIT_TO_WIDTH_OFF';
export const FIT_TO_WIDTH_ON = 'FIT_TO_WIDTH_ON';
export const FOCUS_RESTORED = 'FOCUS_RESTORED';
export const LOADED_PDF = 'LOADED_PDF';
export const LOADING_ABSTRACT = 'LOADING_ABSTRACT';
export const LOADING_AUTHOR = 'LOADING_AUTHOR';
export const LOADING_AUTHOR_CONTEXT = 'LOADING_AUTHOR_CONTEXT';
export const LOADING_CITING_ARTICLES = 'LOADING_CITING_ARTICLES';
export const LOADING_CONNECTIONS = 'LOADING_CONNECTIONS';
export const LOADING_DOCUMENT_FOR_PRINT = 'LOADING_DOCUMENT_FOR_PRINT';
export const LOADING_EXTRAS = 'LOADING_EXTRAS';
export const LOADING_FIGURES = 'LOADING_FIGURES';
export const LOADING_PDF = 'LOADING_PDF';
export const LOADING_RECOMMENDATIONS = 'LOADING_RECOMMENDATIONS';
export const LOADING_REFERENCES = 'LOADING_REFERENCES';
export const LOADING_REFERENCES_CONTEXT = 'LOADING_REFERENCES_CONTEXT';
export const LOADING_SIBLINGS = 'LOADING_SIBLINGS';
export const LOAD_OUTLINE = 'LOAD_OUTLINE';
export const LOAD_PDF_FAILED = 'LOAD_PDF_FAILED';
export const LOADED_PDF_OBJECT_URL = 'LOADED_PDF_OBJECT_URL';
export const NAVIGATE_TO_OCCURRENCE = 'NAVIGATE_TO_OCCURRENCE';
export const OPEN_AUTHOR = 'OPEN_AUTHOR';
export const OPEN_PANEL = 'OPEN_PANEL';
export const OPEN_REFERENCE = 'OPEN_REFERENCE';
export const OPEN_SEARCH = 'OPEN_SEARCH';
export const RECEIVED_ABSTRACT = 'RECEIVED_ABSTRACT';
export const RECEIVED_ABSTRACT_FAILED = 'RECEIVED_ABSTRACT_FAILED';
export const RECEIVED_AUTHOR = 'RECEIVED_AUTHOR';
export const RECEIVED_AUTHOR_CONTEXT = 'RECEIVED_AUTHOR_CONTEXT';
export const RECEIVED_AUTHOR_CONTEXT_FAILED = 'RECEIVED_AUTHOR_CONTEXT_FAILED';
export const RECEIVED_AUTHOR_FAILED = 'RECEIVED_AUTHOR_FAILED';
export const RECEIVED_CITING_ARTICLES = 'RECEIVED_CITING_ARTICLES';
export const RECEIVED_CITING_ARTICLES_FAILED = 'RECEIVED_CITING_ARTICLES_FAILED';
export const RECEIVED_CONNECTIONS = 'RECEIVED_CONNECTIONS';
export const RECEIVED_CONNECTIONS_FAILED = 'RECEIVED_CONNECTIONS_FAILED';
export const RECEIVED_EXTRAS = 'RECEIVED_EXTRAS';
export const RECEIVED_EXTRAS_FAILED = 'RECEIVED_EXTRAS_FAILED';
export const RECEIVED_FIGURES = 'RECEIVED_FIGURES';
export const RECEIVED_FIGURES_FAILED = 'RECEIVED_FIGURES_FAILED';
export const RECEIVED_RECOMMENDATIONS = 'RECEIVED_RECOMMENDATIONS';
export const RECEIVED_RECOMMENDATIONS_FAILED = 'RECEIVED_RECOMMENDATIONS_FAILED';
export const RECEIVED_REFERENCES = 'RECEIVED_REFERENCES';
export const RECEIVED_REFERENCES_CONTEXT = 'RECEIVED_REFERENCES_CONTEXT';
export const RECEIVED_REFERENCES_CONTEXT_FAILED = 'RECEIVED_REFERENCES_CONTEXT_FAILED';
export const RECEIVED_REFERENCES_FAILED = 'RECEIVED_REFERENCES_FAILED';
export const RECEIVED_SIBLINGS = 'RECEIVED_SIBLINGS';
export const RECEIVED_SIBLINGS_FAILED = 'RECEIVED_SIBLINGS_FAILED';
export const ROTATE_CLOCKWISE = 'ROTATE_CLOCKWISE';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const SEARCH_FOUND = 'SEARCH_FOUND';
export const SEARCH_NOT_FOUND = 'SEARCH_NOT_FOUND';
export const SET_CLIENT_SIZE = 'SET_CLIENT_SIZE';
export const SET_DEFAULT_PAGE_SIZE = 'SET_DEFAULT_PAGE_SIZE';
export const SET_PAGE = 'SET_PAGE';
export const SET_SCALE = 'SET_SCALE';
export const SET_SIDEBAR_WIDTH = 'SET_SIDEBAR_WIDTH';
export const SET_TOOLBAR_BUTTON_LIST_WIDTH = 'SET_TOOLBAR_BUTTON_LIST_WIDTH';
export const SET_TOOLBAR_LIST_CONTAINER_WIDTH = 'SET_TOOLBAR_LIST_CONTAINER_WIDTH';
